export const authClientAdditionalFields = {
  user: {
    customerId: {
      type: 'string',
      required: false,
    },
    preferredLocale: {
      type: 'string',
      required: false,
    },
  },
} as const;
